import React from "react";
import LText from "../LText";
import LPressable from "@components/LPressable";
import { CollectionTitlesProps } from "@components/Collection/CollectionTitles";

interface SubTitleTextProps {
  numberOfLines?: number;
  onPress: () => void;
  subtitle: CollectionTitlesProps["subtitle"];
}

const CollectionSubtitle: React.FC<SubTitleTextProps> = ({
  numberOfLines,
  onPress,
  subtitle,
}) => {
  if (!subtitle) return null;

  return (
    <LPressable
      sentryEventName={`music_player_artist_name_button`}
      onPress={onPress}
    >
      <LText numberOfLines={numberOfLines} variant="collectionSubtitle">
        {subtitle}
      </LText>
    </LPressable>
  );
};

export default CollectionSubtitle;
